import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Header from './components/Header';
import LoginScreen from './screens/LoginScreen';
import ChangePasswordScreen from './screens/ChangePasswordScreen';
import AdminDashboardScreen from './screens/AdminDashboardScreen';
import StaffDashboardScreen from './screens/StaffDashboardScreen';
import BirthdayWrapper from './components/BirthdayWrapper';
import { Toaster } from 'react-hot-toast';
import sessionManager from './utils/sessionManager';

// Dynamic Title Hook
function useDynamicTitle(title) {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = `${title} - Shahji Computers ERP`;
    
    return () => {
      document.title = originalTitle;
    };
  }, [title]);
}

// Protected Route Component
function ProtectedRoute({ children, requiredRole = null }) {
  const { userInfo } = useSelector((state) => state.auth);
  
  if (!userInfo || !userInfo.token) {
    return <Navigate to="/login" replace />;
  }
  
  if (requiredRole && userInfo.role !== requiredRole) {
    // Redirect to appropriate dashboard based on role
    if (userInfo.role === 'Admin') {
      return <Navigate to="/admin-dashboard" replace />;
    } else {
      return <Navigate to="/staff-dashboard" replace />;
    }
  }
  
  return children;
}

function AppContent() {
  const location = useLocation();
  const { userInfo } = useSelector((state) => state.auth);
  const isDashboardRoute = location.pathname === '/admin-dashboard' || location.pathname === '/staff-dashboard';
  const isLoginRoute = location.pathname === '/login';

  useEffect(() => {
    // Initialize session management when user is logged in
    if (userInfo && userInfo.token) {
      sessionManager.start();
    } else {
      sessionManager.stop();
    }

    // Cleanup on unmount
    return () => {
      sessionManager.stop();
    };
  }, [userInfo]);

  return (
    <>
      {!isDashboardRoute && !isLoginRoute && <Header />}
      <main className={isDashboardRoute || isLoginRoute ? '' : 'py-3'}>
        <div className={isDashboardRoute || isLoginRoute ? '' : 'container mx-auto'}>
          <Routes>
            <Route path="/login" element={<LoginScreen />} />
            <Route path="/change-password" element={<ChangePasswordScreen />} />
            <Route 
              path="/admin-dashboard" 
              element={
                <ProtectedRoute requiredRole="Admin">
                  <BirthdayWrapper>
                    <AdminDashboardScreen />
                  </BirthdayWrapper>
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/staff-dashboard" 
              element={
                <ProtectedRoute requiredRole="Staff">
                  <BirthdayWrapper>
                    <StaffDashboardScreen />
                  </BirthdayWrapper>
                </ProtectedRoute>
              } 
            />
            {/* Legacy routes for backward compatibility */}
            <Route path="/admin/dashboard" element={<Navigate to="/admin-dashboard" replace />} />
            <Route path="/staff/dashboard" element={<Navigate to="/staff-dashboard" replace />} />
            {/* Default route */}
            <Route path="/" element={
              userInfo ? (
                userInfo.role === 'Admin' ? 
                  <Navigate to="/admin-dashboard" replace /> : 
                  <Navigate to="/staff-dashboard" replace />
              ) : (
                <Navigate to="/login" replace />
              )
            } />
          </Routes>
        </div>
      </main>
      <Toaster />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;

